import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@driftt/tide-core'
import { createApp } from 'api/developerApi'
import { withRouter } from 'react-router-dom'
import cx from 'classnames'


class CreateAppButton extends Component {
  state = {
    isProcessing: false
  }

  static propTypes = {
    showErrorNotification: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };

  createNewApp = () => {
    const onDone = (app) => {
      this.props.history.push(`/app/${app.id}`)
    }

    const onError = (error) => {
      this.props.showErrorNotification('Ooops, something went wrong. Please try again.')
    }

    const onFinally = () => {
      this.setState({ isProcessing: false })
    }

    const onStateSet = () => {
      createApp()
        .then(onDone)
        .catch(onError)
        .then(onFinally)
    }

    this.setState({ isProcessing: true }, onStateSet)
  }

  render() {
    const { isProcessing } = this.state
    const { className } = this.props

    return (
      <Button
        className={cx(className)}
        size="medium"
        loading={isProcessing}
        onClick={this.createNewApp}>
        Build Your App
      </Button>
    )
  }
}

export default withRouter(CreateAppButton)
